

import axios from 'axios'
import { EventTypes } from 'redux-segment'

export function fetchCombinedDataViews(companyParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'COMBINED_DATA_VIEWS_FETCH',
      payload: axios(`/companies/${companyParam}/combined_data_views`)
    })
  }
}

export function fetchChildCompanyCombinedDataViews(companyParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHILD_COMPANY_COMBINED_DATA_VIEWS_FETCH',
      payload: axios(`/companies/${companyParam}/child_company_combined_data_views`)
    })
  }
}

export function fetchDataView(companyParam,siteParam,dataViewParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'DATA_VIEW_FETCH',
      payload: axios(`/companies/${companyParam}/data_views/${dataViewParam}`)
    })
  }
}

export function fetchDataViewHash(companyParam,dataViewParam) {
  return (dispatch, getState) => {
    dispatch({
      type: 'COMBINED_DATA_VIEW_HASH_FETCH',
      payload: axios(`/companies/${companyParam}/data_views/${dataViewParam}/data_view_hash`)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/CombinedDataViewActions.js